import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import authApi from "services/apis/authApi";
import { OTP_SCREEN_TYPE } from "./AuthOTP";
import StorageManager from "utils/storageManager";
import ROUTES from "routes/constant";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [emailAddress, setEmailAddress] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await authApi.generateOtpForForgotPassword({
        emailId: emailAddress,
      });

      StorageManager.set("otpSentTime", moment().toISOString());
      toast.success("OTP has been sent!");

      navigate(ROUTES.AUTH.FORGOT_PASSWORD_OTP, {
        state: {
          username: emailAddress,
          type: OTP_SCREEN_TYPE.FORGOT_PASSWORD,
        },
      });
    } catch (error) {
      /* empty */
    }
  };
  return (
    <>
      {/* {err && <Alert variant="danger">{err}</Alert>} */}
      <Form onSubmit={handleSubmit}>
        <div className="form-container">
          <div className="heading ">
            <h5>Email registered email address to reset password</h5>
          </div>
        </div>

        <Form.Group
          className="text-start form-group my-4"
          controlId="formEmail"
        >
          <Form.Label>Email</Form.Label>
          <Form.Control
            placeholder="Enter your email"
            name="username"
            type="email"
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
            required
            className="form-control"
          />
        </Form.Group>

        <Button
          type="submit"
          className="btn ripple btn-main-primary btn-block mb-2 text-uppercase"
        >
          SUBMIT
        </Button>

        <div className="form-group text-center">
          <NavLink to={ROUTES.AUTH.LOGIN}>
            Back to <b>Log-in</b>
          </NavLink>
        </div>
      </Form>
    </>
  );
};

export default ForgotPassword;
